import { faCamera } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "modules/AppointmentDetails/components/Interventions/components/PinOverview/components/ImageGallery/ImageGallery.scss";

import type { QuestionResultLetteredImage } from "modules/AppointmentDetails/components/Interventions/components/PinOverview/components/ChecklistSection/hooks";

type Props = {
  checkId: number;
  letteredImages: QuestionResultLetteredImage[];
};

const IMAGES_PER_ROW = 4;

const chunkImages = (images: QuestionResultLetteredImage[], chunkSize: number) => {
  const chunks: (QuestionResultLetteredImage | null)[][] = [];
  for (let i = 0; i < images.length; i += chunkSize) chunks.push(images.slice(i, i + chunkSize));

  const lastChunk = chunks[chunks.length - 1];
  while (lastChunk.length < chunkSize) lastChunk.push(null);

  return chunks;
};

export const ImageGallery = ({ checkId, letteredImages }: Props) => {
  if (!letteredImages.length) return null;

  return (
    <div className="ImageGallery">
      <div className="images-container">
        {chunkImages(letteredImages, IMAGES_PER_ROW).map((row, idx) => (
          <div className="image-container-row" key={"image-container-row-" + checkId + "-" + idx}>
            {row.map((image, cellIdx) =>
              image ? (
                <div className="image-container" key={image.id}>
                  <div className="img-label">
                    <div className="img-icon-wrapper">
                      <FontAwesomeIcon icon={faCamera} size="sm" />
                      <span className="report-car-images-letter">{image.letterCode}</span>
                    </div>
                  </div>
                  <img alt={`img-${image.letterCode}`} className="image-style" src={image.url} />
                </div>
              ) : (
                <div className="image-container" key={"image-container-empty-" + checkId + "-" + idx + "-" + cellIdx} />
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
